const e = {
  name: "Number2Circle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{clip-path:url(#SVGID_00000178922013635402301690000012841601828920304058_);}
	.st1{fill: currentColor;}
</style>
<g>
	<defs>
		<rect id="SVGID_1_" width="40" height="40"/>
	</defs>
	<clipPath id="SVGID_00000101800516252724906200000018283504673297188004_">
		<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
	</clipPath>
	<g style="clip-path:url(#SVGID_00000101800516252724906200000018283504673297188004_);">
		<path class="st1" d="M24,21v-7h-8v2h6v3h-6v7h8v-2h-6v-3H24z"/>
		<path class="st1" d="M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20S31,0,20,0z M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18s-8.1,18-18,18
			S2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Number2Circle
};
